import React from 'react';
import {
  calculatePasswordStrength,
  PasswordStrengthPercent
} from '@Client/runner.services/password.strength.calculator';
import './UserPasswordStrength.scss';

type UserPasswordStrengthProps = {
  password?: string;
};

const PASSWORD_STRENGTH_WIDTH_CLASS_BY_PERCENT: Record<
  PasswordStrengthPercent,
  string
> = {
  [PasswordStrengthPercent.VeryWeak]: 'user-password-strength__bar--20',
  [PasswordStrengthPercent.Weak]: 'user-password-strength__bar--40',
  [PasswordStrengthPercent.Fair]: 'user-password-strength__bar--60',
  [PasswordStrengthPercent.Good]: 'user-password-strength__bar--80',
  [PasswordStrengthPercent.Strong]: 'user-password-strength__bar--100'
};

export const UserPasswordStrength = ({
  password
}: UserPasswordStrengthProps) => {
  if (!password) {
    return null;
  }

  const passwordStrengthResult = calculatePasswordStrength(password);

  const strengthWidthClassName =
    PASSWORD_STRENGTH_WIDTH_CLASS_BY_PERCENT[passwordStrengthResult.strength];

  return (
    <div className="user-password-strength m-0">
      <div className="user-password-strength__progress progress small">
        <div
          className={`user-password-strength__bar ${strengthWidthClassName} white-text ${passwordStrengthResult.color}`}
        />
      </div>
      <div className="user-password-strength__label mb-10">
        The password strength is{' '}
        <strong>{passwordStrengthResult.strengthText}</strong>
      </div>
      {passwordStrengthResult.suggestions.map((suggestion, suggestionIndex) => (
        <div
          className="user-password-strength__suggestion password-calculator-suggestions"
          key={`${suggestion}-${suggestionIndex}`}
        >
          {suggestion}
        </div>
      ))}
    </div>
  );
};
